import { useAccount } from './requests/use-account';

export function useIsIssueOnEndOfMonthActive(): boolean {
  const { data: accountData } = useAccount();

  return accountData?.account.settings.invoicingSettings?.issueOnEndOfMonth ?? false;
}
